import { AfterContentChecked, Component, ElementRef, Input, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { FieldType, FormlyFieldConfig } from '@ngx-formly/core';
import { debounceTime, Subject, takeUntil } from 'rxjs';
import { CountryISO } from 'ngx-intl-tel-input';
import { FormHooksService } from 'src/app/core/services/form-hooks.service';

interface InternationalPhoneValue {
  number: string;
  internationalNumber: string;
  nationalNumber: string;
  e164Number: string;
  countryCode: string;
  dialCode: string;
}
@Component({
    selector: 'ups-input-phone',
    template: `<div>
    <label class="d-block">
      <abbr title="Required" class="slds-required ng-star-inserted" *ngIf="to.required">*</abbr>
      {{ to.label || '' }}
    </label>
    <ngx-intl-tel-input
      [cssClass]="'intl-tel'"
      [searchCountryFlag]="true"
      [required]="to.required || false"
      [formControl]="$any(formControl)"
      [formlyAttributes]="field"
      [required]="to.required || false"
      [selectedCountryISO]="selectedCountry"
    ></ngx-intl-tel-input>
  </div>`,
    styleUrls: ['./phone.type.component.scss'],
    standalone: false
})
export class PhoneTypeComponent extends FieldType implements OnInit, OnDestroy, AfterContentChecked {
  public subject = new Subject<any>();
  private destroy$: Subject<void> = new Subject<void>();
  public selectedCountry = CountryISO.UnitedStates;

  @Input() set defaults(opt: FormlyFieldConfig) {
    this.field = opt;
  }

  get type() {
    return this.to.type || 'phone';
  }

  constructor(private render: Renderer2, private formHooksService: FormHooksService) {
    super();

    this.formHooksService.samePrimaryPhone$.pipe(takeUntil(this.destroy$)).subscribe((val) => {
      if (this.key === 'primaryPhoneAssistance') {
        this.formControl.setValue(val.value);
      }
    });
  }

  ngOnInit(): void {
    // Formly assigns the field/key after construction, before replaying the saved country.
    this.formHooksService.selectedCountry$.pipe(takeUntil(this.destroy$)).subscribe((val) => {
      const foundCountryIso = this.findCountryIso(val.data);
      if (foundCountryIso) {
        if (
          (val.emitter === 'country' && (this.key === 'primaryPhone' || this.key === 'mobilePhone')) ||
          // Incident Location also drives Contact Details phones, not just Requirement Assistance
          (val.emitter === 'inquirerCountry' && (this.key === 'primaryPhoneAssistance' || this.key === 'primaryPhone' || this.key === 'mobilePhone'))
        ) {
          this.selectedCountry = val.data;
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngAfterContentChecked(): void {
    const getElement: ElementRef | any = document.querySelector(`ngx-intl-tel-input .search-container input`);
    if (getElement && !getElement.getAttribute('autocomplete')) {
      this.render.setAttribute(getElement, 'autocomplete', 'nope');
      this.render.setAttribute(getElement, 'type', 'search');
    }
  }

  private enumKeys<O extends object, K extends keyof O = keyof O>(obj: O): K[] {
    return Object.keys(obj).filter((k) => Number.isNaN(+k)) as K[];
  }

  private findCountryIso(value: string): string | null {
    for (const countryId of this.enumKeys(CountryISO)) {
      if (value === CountryISO[countryId]) {
        return value;
      }
    }
    return null;
  }
}
